import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { CommonModule, DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Ng2Webstorage } from 'ngx-webstorage';
import { MyDatePickerModule } from 'mydatepicker';
import { AppComponent } from './app.component';
import { AppCommonModule } from './common/common.module';
import { UtilsModule } from './utils/utils.module';
import { AdminModule } from './admin/admin.module';
import { RmModule } from './rm/rm.module';
import { EmployeeModule } from './employee/employee.module';
import { AppRoutingModule } from './app-routing.module';
import { AppService } from './app.service';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { AutosizeModule } from 'ngx-autosize';
import 'hammerjs';
import { MsalModule } from "@azure/msal-angular/dist/msal.module";
import { MsalInterceptor } from "@azure/msal-angular/dist/msal.interceptor";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { HttpServiceHelper } from './common/HttpServiceHelper';
import { msConfig } from "./../environments/azureconfig"

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    UtilsModule,
    Ng2Webstorage,
    AdminModule,
    EmployeeModule,
    RmModule,
    AppCommonModule,
    AppRoutingModule,
    MyDatePickerModule,
    BrowserAnimationsModule,
    AutosizeModule,
    Ng4LoadingSpinnerModule.forRoot(),
    HttpClientModule,
    MsalModule.forRoot(msConfig),
  ],
  providers: [
    AppService,HttpServiceHelper,
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts